export default "__VITE_ASSET__ByNPM7q0__"